import axios from "axios";
import {
  COMMON_ERROR_MSG,
  ERROR_CODE_MAP,
  NEED_LOGIN_ERROR_MSG,
} from "../js/constant";
import { axios_get, axios_post } from "../../../../network/requestNew";
import MessageBox from "../../../../components/message-box";

/**
 * 请求封装
 * @param url
 * @param params 请求参数
 * @param options 请求 headers 等
 * @param fullResponse 完整返回接口内容（含 code, msg 等）
 * @returns
 */
function sendPost(
  url: string,
  params?: any,
  options?: any,
  fullResponse?,
  showCommonErrorMsg = true,
) {
  return axios_post(url, params, options, fullResponse)
    .then((ret) => {
      if (fullResponse) {
        const { code } = ret;
        if (code === 200) {
          return Promise.resolve(ret);
        } else if (code === ERROR_CODE_MAP.NEED_LOGIN) {
          MessageBox.confirm(NEED_LOGIN_ERROR_MSG);
          return;
        } else if (code === ERROR_CODE_MAP.ORDER_REPEAT) {
          MessageBox.toast("车辆已经在救援中。如需查询进度，请回到救援首页。", {
            timeout: 3000,
          });
          return;
        }
        return Promise.reject(ret);
      }
      return Promise.resolve(ret);
    })
    .catch((err) => {
      if (showCommonErrorMsg) {
        MessageBox.confirm(COMMON_ERROR_MSG);
      } else {
        return Promise.reject(err);
      }
    });
}

/**
 * 创建救援工单
 * @param params
 * @returns
 * http://apisix-internal-gateway-test.xiaopeng.com/xp-dragon-koi-boot/doc.html#/WEB%E6%8E%A5%E5%8F%A3/%E7%A7%BB%E5%8A%A8%E6%95%91%E6%8F%B4/createUsingPOST_1
 */
export function createRescueOrder(params) {
  return sendPost(
    "/xp-dragon-koi-boot/mobile/rescue/create",
    params,
    {},
    true,
    false,
  );
}

/**
 * 查询技师的GPS信息
 * @param params { orderNumber: xxx }
 * @returns
 */
export function queryUserInfo() {
  return sendPost("/xp-dragon-koi-boot/mobile/rescue/get-user", {}, {}, true);
}

/**
 * 查询救援工单列表
 * http://apisix-internal-gateway-test.xiaopeng.com/xp-dragon-koi-boot/doc.html#/WEB%E6%8E%A5%E5%8F%A3/%E7%A7%BB%E5%8A%A8%E6%95%91%E6%8F%B4/getUserRescuingOrderUsingPOST
 */
export function queryRescueOrderList() {
  return sendPost(
    "/xp-dragon-koi-boot/mobile/rescue/get-user-rescuing-order",
    {},
    {},
    true,
  );
}

/**
 * 附件上传token获取接口
 * @returns
 */
export function getFileUploadTokenInfo(params) {
  return sendPost(
    "/xp-dragon-koi-boot/mobile/rescue/getFileUploadTokenInfo",
    params,
  );
}

// 图片附件上传接口
export function imgFileInfoUpload(params) {
  return sendPost("/xp-dragon-koi-boot/mobile/rescue/fileUpload", params);
}

/**
 * 获取附件列表
 * @param params { orderNumber: 'xxx' }
 * @returns
 */
export function queryImgFileList(params) {
  return sendPost("/xp-dragon-koi-boot/mobile/rescue/queryFileList", params);
}

/**
 * 查询首页基础数据
 * @returns
 */
export function queryIndexInfo() {
  return sendPost(
    "/xp-dragon-koi-boot/mobile/rescue/get-user-index",
    {},
    {},
    true,
  );
}

/**
 * 查询首页配置信息
 * @returns
 */
export function queryIndexConfig() {
  return axios_get("/xp-dragon-koi-boot/mobile/rescue/get-index");
}

/**
 * 根据 fileId 删除文件
 * @returns
 */
export function deleteSpecImageFile(params) {
  return sendPost("/xp-dragon-koi-boot/mobile/rescue/deleteFile", params);
}

/**
 * 查询技师的GPS信息
 * @param params { orderNumber: xxx }
 * @returns
 */
export function queryDriverGPSInfo(params) {
  return sendPost(
    "/xp-dragon-koi-boot/mobile/rescue/queryGPSInfo",
    params,
    {},
    false,
    false,
  );
}

/**
 * 获取是否灰度
 */
export const queryGray = (uid) => {
  return axios.request({
    baseURL: "",
    url: `/api/xp-dragon-koi-boot/mobile/rescue/gray-scale?uid=${uid}`,
    method: "get",
    timeout: 10000,
    responseType: "json",
  });
};

/**
 * 获取是否灰度 - web
 */
export const queryWebGray = (params) => {
  return sendPost(
    `/xp-dragon-koi-boot/mobile/rescue/web-gray-scale`,
    params,
    {},
    false,
    false,
  );
};

/**
 * 获取拖车钩图片
 * @param plateNo 车牌号
 * @returns Promise<string> 拖车钩图片 URL
 */
export const getTowbarImage = async (params: { carLicenseNo: string }) => {
  return sendPost(
    `/xp-dragon-koi-boot/mobile/rescue/get-vehicle-towbar-image`,
    params,
    {},
    false,
    false,
  );
};

/**
 * 获取门店列表
 * @param longitude 经度
 * @param latitude 纬度
 * @returns Promise<any[]> 门店列表
 * http://apisix-internal-gateway-test.xiaopeng.com/xp-dragon-koi-boot/doc.html#/WEB%E6%8E%A5%E5%8F%A3/%E7%A7%BB%E5%8A%A8%E6%95%91%E6%8F%B4/getShopLocationListUsingPOST
 */
export const getShopList = async (params: {
  limit: number;
  rescueLat: string;
  rescueLon: string;
  shopName?: string;
  uid?: number;
}): Promise<any[]> => {
  return sendPost(
    `/xp-dragon-koi-boot/mobile/rescue/get-shop-location-list`,
    params,
    {},
    false,
    false,
  );
};

/**
 * 获取车辆定位
 * @param params { frontRedirect, preUid, uid, vin }
 * @returns Promise<VehLocationInfoDTO>
 */
export const getVehLocationAuth = async (params: {
  frontRedirect: string;
  preUid?: string;
  uid?: number;
  vin: string;
}) => {
  return sendPost(
    `/xp-dragon-koi-boot/mobile/rescue/get-veh-location-auth`,
    params,
    {},
    false,
    false,
  );
};

/**
 * 取消救援
 * @returns Promise<void>
 * http://apisix-internal-gateway-test.xiaopeng.com/xp-dragon-koi-boot/doc.html#/WEB%E6%8E%A5%E5%8F%A3/%E7%A7%BB%E5%8A%A8%E6%95%91%E6%8F%B4/cancelApplyUsingPOST
 */
export const cancelRescue = async (params: {
  cancelReason: string; // 取消原因
  orderNumber: string; // 救援单号
}) => {
  return sendPost(
    `/xp-dragon-koi-boot/mobile/rescue/cancel-apply`,
    params,
    {},
    false,
    false,
  );
};
